import List from "./List";
import Preview from "./Preview";
import Finished from "./Finished";
import Valoration from "./Valoration";

const Pages = {
  List,
  Preview,
  Finished,
  Valoration,
};

export default Pages;
